"use client";

import type { JSX, SVGProps } from "react";
import { MenuIcon } from "@/assets/icons";
import { BuildingIcon, User, Chat, ContactIcon, BellIcon } from "../sidebar/icons";
import { useSidebarContext } from "../sidebar/sidebar-context";
// import { Notification } from "./notification";
import { Currency } from "./currency";
import { ThemeToggleSwitch } from "./theme-toggle";
import { UserInfo } from "./user-info";
import { Link } from "@/i18n/navigation";
import { Logo } from "@/components/logo";

const QUICK_LINKS: {
  href: string;
  label: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}[] = [
  { href: "/institutions", label: "Institutions", icon: BuildingIcon },
  { href: "#", label: "System Users", icon: User },
  { href: "/support", label: "Support", icon: Chat },
  { href: "/contacts-email", label: "Contacts", icon: ContactIcon },
  // { href: "/push-notifications", label: "Notifications", icon: BellIcon },
];

function QuickLink({
  href,
  label,
  icon: Icon,
}: {
  href: string;
  label: string;
  icon: (props: SVGProps<SVGSVGElement>) => JSX.Element;
}) {
  return (
    <Link
      href={href}
      aria-label={label}
      className="group relative flex h-9 w-9 items-center justify-center rounded-full text-white/70 transition-colors hover:bg-white/10 hover:text-white"
    >
      <Icon className="h-[18px] w-[18px]" />
      <span className="pointer-events-none absolute left-1/2 top-full z-50 mt-2 -translate-x-1/2 whitespace-nowrap rounded-md bg-white px-2.5 py-1 text-xs font-medium text-slate-900 opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100">
        {label}
      </span>
    </Link>
  );
}

export function Header() {
  const { toggleSidebar, isMobile } = useSidebarContext();

  return (
    <header className="bg-dark sticky top-0 z-30 flex items-center gap-2 pr-4 py-4 md:pr-5 2xl:pr-6">
      <div className="flex shrink-0 items-center">
        <button
          onClick={toggleSidebar}
          className="cursor-pointer rounded-xl pr-6 pl-2 py-1.5 transition-colors duration-200"
        >
          <MenuIcon />
          <span className="sr-only">Toggle Sidebar</span>
        </button>
        <Link href={'/'} className="px-0">
          <Logo />
        </Link>
      </div>

      {/* Quick Links */}
      <nav aria-label="Quick links" className="hidden flex-1 items-center justify-center gap-1 md:flex">
        {QUICK_LINKS.map((link) => (
          <QuickLink key={link.href} {...link} />
        ))}
      </nav>

      <div className="ml-auto flex items-center gap-2 min-[375px]:gap-3">
        {/* <div className="border-stroke/70 bg-gray-1/60 dark:border-white/8 flex items-center gap-1.5 rounded-full border p-1 dark:bg-white/5">
          <ThemeToggleSwitch />
        </div> */}
        {/* <Notification /> */}
        <div className="h-6 w-px" />
        <UserInfo />
      </div>
    </header>
  );
}
